import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import { FilterStateCampaignPropagation, DEFAULT_FILTERS } from "../types";

export const useFilterState = (): FilterStateCampaignPropagation => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const page = parseInt(searchParams.get("page") || String(DEFAULT_FILTERS.page));
    const limit = parseInt(searchParams.get("limit") || String(DEFAULT_FILTERS.limit));
    const campaignType = searchParams.get("campaignType") as any;
    const overallStatus = searchParams.get("overallStatus") as any;

    return {
      page: isNaN(page) ? DEFAULT_FILTERS.page : page,
      limit: isNaN(limit) ? DEFAULT_FILTERS.limit : limit,
      ...(campaignType && { campaignType }),
      ...(overallStatus && { overallStatus }),
    };
  }, [searchParams]);
};
